import React from 'react'
import styled from 'styled-components'
import { Color } from '../common/style/color'
import { CustomButton } from '../common/style/components/button'
import { Image } from '../common/style/components/image'
import { mobile } from '../common/style/media-queries'
import cross from './cross.svg'

export const BannerBox: React.FC<{
  onClose: () => void
  className?: string
}> = ({ children, onClose, className }) => (
  <Wrapper role="region" aria-label="cookie consent" className={className}>
    <CloseButton onClick={onClose}>
      <Image src={cross} alt="close" />
    </CloseButton>
    {children}
  </Wrapper>
)

const Wrapper = styled.div`
  position: fixed;
  bottom: 35px;
  left: 35px;
  width: 420px;
  max-width: calc(100% - 70px);
  border-radius: 5px;
  box-shadow: 0 2px 20px 0 rgba(130, 178, 255, 0.15);
  background-color: #ffffff;
  z-index: 10;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media ${mobile} {
    left: 18px;
    bottom: 10px;
    max-width: calc(100% - 36px);
  }
`

const CloseButton = styled(CustomButton)`
  position: absolute;
  right: 15px;
  top: 15px;
`

export const BoxContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
`

export const Actions = styled.div`
  display: flex;
  width: 100%;
  border-top: solid 1px rgba(130, 178, 255, 0.15);
`

export const ActionDivider = styled.div`
  border-left: solid 1px rgba(130, 178, 255, 0.15);
  height: 40px;
  width: 1px;
`

export const Button = styled(CustomButton)<{ color: Color }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  height: 40px;
  color: ${props => props.color};
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.03em;
`

export const BoxIllustration = styled(Image)`
  width: 104px;
`

export const BoxTitle = styled.h3`
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  color: ${Color.grey_600};
  text-align: center;
`

export const BoxPresentation = styled.p`
  text-align: center;
  font-size: 14px;
  color: ${Color.grey_600};
  line-height: 20px;
  margin-top: 0;
`
